import { Registration } from './dtos/Registration.schema.d'
import axios from 'axios'
import { LoginCredentials } from './dtos/LoginCredentials.schema'
import jwtDecode from 'jwt-decode'

export const login = async (email: string, password: string): Promise<void> => {
  const res = await axios.post<string>('/login', {
    email,
    password
  } as LoginCredentials)

  if (res.status === 401) throw new Error('invalid email or password!')
  else if (res.status === 429) throw new Error('too many login retries!')

  // the  auth cookie is automatically set
}

export const logout = async (): Promise<void> => {
  const res = await axios.post<void>(
    '/logout'
  )

  if (res.status === 401) throw new Error('already logged out!')
}

export const completeRegistration = async (
  token: string,
  registration: Registration
): Promise<void> => {
  const res = await axios.post<void>(
    `/complete-registration/${token}`,
    registration
  )
  if (res.status === 401) throw new Error('invalid token!')
  else if (res.status === 429) throw new Error('too many login retries!')
}
